/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Full name of the assigned agent
 * @export
 * @interface AgentName
 */
export interface AgentName {
}

/**
 * Check if a given object implements the AgentName interface.
 */
export function instanceOfAgentName(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AgentNameFromJSON(json: any): AgentName {
    return AgentNameFromJSONTyped(json, false);
}

export function AgentNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgentName {
    return json;
}

export function AgentNameToJSON(value?: AgentName | null): any {
    return value;
}

